/* Maps an entity status to a coloured operator status dot. Green = healthy/live
   (semantic, not brand); amber = warn; red = danger; violet = comp; grey = neutral. */
const MAP: Record<string, string> = {
  ok: "ok", active: "ok", live: "ok",
  degraded: "warn", past_due: "warn", beta: "warn",
  suspended: "danger", killed: "danger", disabled: "danger",
  comp: "violet", draft: "neutral",
};

export function StatusDot({ s }: { s: string }) {
  return <span className={`sdot ${MAP[s] || "neutral"}`} />;
}
